import {
    activityInfo,
    editActivity
} from "@/api/assistantMode/activity";
import {
    dateCount
} from "@/utils/index";

export default {
    data() {
        return {
            info: {}, // 活动信息
            surplus: "", // 剩余时间
        }
    },
    activated() {
        this.getInfo();
        this.getList();
        this.timerId && clearInterval(this.timerId);
        this.timerId = setInterval(() => {
            if (this.info.status == "STOP") {
                clearInterval(this.timerId);
            }
            this.getInfo();
            this.getList();
        }, 3000);
    },
    deactivated() {
        clearInterval(this.timerId);
    },
    methods: {
        // 活动信息
        getInfo() {
            let activityId = this.$route.query.activityId;
            activityInfo(activityId).then((res) => {
                if (res.code == 0) {
                    this.info = res.data;
                    let end = new Date(this.info.startTime).getTime();
                    let duration = this.info.duration * 60 * 1000;
                    end = end + duration;
                    let nowTime = +new Date();
                    let times = (end - nowTime) / 1000;
                    if (times > 0) this.surplus = dateCount(times);
                } else {
                    console.log(res.msg);
                }
            });
        },
        // 结束活动
        handleStop() {
            this.$confirm(`确定要结束该活动吗？`, {
                type: "warning",
            }).then(() => {
                this.info.status = "STOP";
                editActivity(this.info)
                    .then((res) => {
                        if (res.code == 0) {
                            this.$message.success(`活动已结束`);
                            this.getInfo();
                            this.getList();
                        } else {
                            this.$message.error(res.msg);
                        }
                    })

            }).catch(() => {});
        },
        back() {
            this.$store.commit("SET_UPDATE", true);
            this.$router.go(-1);
        },

    }
}